<template>
    <b-modal
        v-if="invitation !== null"
        size="lg"
        v-model="modalShow"
        title="利用アカウント発行のキャンセル"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <div class="text-center mt-4 mb-3">
            <div>以下メールアドレスの利用アカウント発行をキャンセルします。</div>
            <div class="font-weight-bold">{{ invitation.email }}</div>
        </div>
        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <div class="d-flex justify-content-center">
                <button
                    class="btn btn-yokumiru-gray mr-2"
                    :disabled="inProgress"
                    @click="close">
                    閉じる
                </button>
                <button
                    class="btn btn-danger"
                    :disabled="inProgress"
                    @click="handleOk">
                    キャンセルする
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../../constants'
import YokumiruHelper from '../../../../YokumiruHelper'

export default {
    props: {
        group: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            invitation: null,
        }
    },

    created: function () {
        bus.$on('open-modal-authorizer-group-invitation-cancel', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-authorizer-group-invitation-cancel')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} invitation
         */
        open: function (invitation) {
            this.invitation = {...invitation}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * ボタン押下時
         *
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.cancelInvitation()
        },

        /**
         * 利用アカウント発行のキャンセル
         */
        cancelInvitation: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.user.groups.endpoint.base

            await axios.delete(`${endpoint}/${this.group.id}/invitations/${this.invitation.id}`, this.invitation)
                .then(() => {
                    bus.$emit('alert-success', `利用アカウント発行をキャンセルしました。`)
                    bus.$emit('group-invitation-canceled')
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')
                    ) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>
